import { PropsWithChildren, StrictMode } from "react"
import { Header } from "common/components/Header"
import { Footer } from "common/components/Footer"
import { PromosContext } from "modules/promos/contexts/PromosContext"
import { Slot } from "modules/promos/components/Slot/Slot"

export const Content = ({ children }: PropsWithChildren<{}>) => {
  return (
    <main id="main-content" tabIndex={-1} className="tc-container container mx-auto my-5">
      {children}
    </main>
  )
}

export const Layout = ({ children }: PropsWithChildren<{}>) => {
  const currentYear = new Date().getFullYear()

  return (
    <StrictMode>
      <PromosContext>
        <div className="flex h-screen flex-col justify-between">
          <Header />

          <Slot name="banner" />

          <Content>{children}</Content>
          <Footer year={currentYear} />
        </div>
        <Slot name="modal" />
      </PromosContext>
    </StrictMode>
  )
}
